/**
 * Interface for the 'Authentication' data
 */
export interface AuthenticationEntity {
    id: string | number; // Primary ID
}
